// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"17046459","255":"f4d227df"}[chunkId] + ".chunk.js";
};